var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOngoing = function SvgOngoing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1378,
    height: 1303,
    viewBox: "-10 0 1378 1303"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M710 1303q-134 0-256-52t-210-139.5T104 903 52 649q0-186 97-343L-10 129 614 0 414 602 283 456q-42 92-42 193 0 95 37 181t100 148.5 149.5 99.5 182 37 182.5-37 149.5-99.5 100-148.5 37.5-181q0-101-41-190.5T1025 304l96-166q115 92 181 225t66 286q0 133-52 254t-140.5 208.5-210 139.5-255.5 52"
  })));
};
export default SvgOngoing;